<template>
  <div class="selectStoresDialog">
    <el-dialog
        title="选择门店"
        :visible.sync="selectStoresVisible"
        center
        custom-class='selectStoresBox'
        width="800px"
        :before-close="handleClose"
    >
      <div class="searchArea">
        <el-input placeholder="请输入门店名称/编号进行查询" v-model="storyName" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-select v-model="storyType">
            <el-option :key="index" v-for="(item,index) in storyTypeOptions" :label='item.label' :value='item.value'></el-option>
        </el-select>   
        <!-- <el-select v-model='areaType'>
            <el-option :key="index" v-for="(item,index) in areaTypeOptions" :label='item.label' :value='item.value'></el-option>
        </el-select> -->
        <el-button class="search-item" type="primary" icon="el-icon-search" >查询</el-button>
        <el-button class="search-item">重置</el-button>  
      </div>
      <div class="tableArea">
        <SimpleTable ref="storesTable" :type="'selection'" :tableStyleName='"dialogTable"' 
          :tableDataTitle='storyTableTitle'
          :tableDataP='storyTableData'
          :showPagination='true'
          :pageTotal='100'
          :prepositiveSelects='prepositiveSelects'
          @whole-select='wholeSelect'
        >
        </SimpleTable>
      </div>
      <div class="footerBtn">
        <el-button type='primary' @click="confirmStores()">确定</el-button>
        <el-button type='default' @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SimpleTable from '@/components/template/simpleTable.vue';
import api from '@/config/api';
export default {
  data(){
    return{
      storyName:'',
      storyType:'',
      // areaType:'',选择区域的
      storyTypeOptions:[
        {label:'选择门店类型',value:''},
        {label:'总部',value:'A01'},
        {label:'直营店',value:'A02'}
      ],
      areaTypeOptions:[
        {label:'选择区域',value:''},
        {label:'默认区域',value:'A01'}
      ],
      storyTableTitle:[
        {
          label:'门店编号',
          prop:'serialNumber'
        },
        {
          label:'门店名称',
          prop:'storyName'
        },
        {
          label:'门店类型',
          prop:'storesType'
        },
        // {
        //   label:'所在区域',
        //   prop:'area'           
        // },
        {
          label:'联系人',
          prop:'contact'           
        },
        {
          label:'联系电话',
          prop:'contactPhone'           
        },
      ],
      storyTableData:[
        {
          id:'',
          serialNumber:'',
          storyName:'',
          storesType:'',
          area:'',
          contact:'',
          contactPhone:''
        },
      ]
    }
  },
  computed:{
    prepositiveSelects:{
      set(){

      },
      get(){
        return this.lastTableData;
      }
    }
  },
  props:['selectStoresVisible','lastFormModel','lastTableData'],
  created(){
    this.getAllEnumeration();
    this.getStoresTableData();
  },
  methods:{
    getStoresTableData(){
      let url=api.system.seStore+'/page';
      let data={
        pageNumber: 1,
        pageSize: 10
      }
      this.storyTableData=[];
      this.$axios.fetchPost(url,data).then((res)=>{
        if(res.code===200){
          let stores=res.data.records;
          for(let i=0;i<stores.length;i++){
            let objectAdaptor={
              id:stores[i].id,
              serialNumber:stores[i].code,
              storyName:stores[i].name,
              storesType:this.fieldShift('storeClass','serve',stores[i]),
              contact:stores[i].contact,
              contactPhone:stores[i].phone,
            }
            this.storyTableData.push(objectAdaptor);
          }

          //实行反选获取反选项    
          this.$refs.storesTable.seaSelect(this.lastTableData,this.storyTableData,'serialNumber');
        }else{
          this.$message.error('门店数据获取失败!'+res.errorMsg)
        } 
      })
    },
    getAllEnumeration(){
      //枚举字段初始化
      this.storyTypeOptions=this.$utils.getCacheStatus('seStore.storeClass');   
      this.storyTypeOptions.unshift({label:'选择门店类型',value:''});
    },
    //字段枚举转化
    fieldShift(field,where='local',data){
      let value;
      if(where==='local'){

      }
      if(where==='serve'){
        switch (field) {
          case 'storeClass':
            let arr=this.$utils.getCacheStatus('seStore.storeClass');
            let store=arr.find((item)=>{
              return item.value===data[field];
            })
            if(store){
              value=store.label;
            }else{
              console.log('该门店类型未缓存')
            }
            break;
        
          default:
            break;
        }
      }
      return value
    },
    confirmStores(){
      //将父组件传来的tableData直接修改.要保有父table的数据不因当前selection中不存在就给用户剔除，可能只是某页selection刚好不存在用户的数据
      console.log('我的数据',this.prepositiveSelects)
      let tempLastTableData=[...this.prepositiveSelects];
      this.$emit('update:lastTableData',tempLastTableData);
      this.$emit('update:selectStoresVisible',false);
    },
    wholeSelect(selection,row){
      console.log('点点滴滴都是',row)
      this.prepositiveSelects=this.$refs.storesTable.positiveSelect(selection,row,this.lastTableData,'serialNumber',this.storyTableData);
    },
    handleCurrentChange(page){
      console.log('dddd')
    },
    handleSizeChange(pagesize){
      console.log('aaaa')
    },
    handleClose(){
      this.$emit('update:selectStoresVisible',false);
    //   let temp={...this.lastFormModel};
    //   temp.storesType='0';
    //   this.$emit('update:lastFormModel',temp);
    }
  },
  components:{
    SimpleTable
  }
}
</script>

<style scoped>
.searchArea{

}
</style>


// WEBPACK FOOTER //
// src/page/promotion/promotionTool/SelectStoresDialog.vue